import {css} from 'styled-components';

export const tableStyles = {
  /**
   * Column headings always show in full (H1MVP-4414).
   *
   * Ant gives a heading the same ellipsis treatment as its body cells whenever the column sets
   * `ellipsis`, which clipped labels down to "Docum...", "Numbe...", "Depart..." — and left two
   * adjacent columns both reading "Docum...", so they could not be told apart. These tables run
   * table-layout: fixed (scroll.x is set in getDefaultTableProps), so a heading may wrap onto a
   * second line instead of pushing the column wider; that also holds for locales whose labels are
   * longer than English.
   *
   * Both `word-break` and `overflow-wrap` have to be pinned to normal. Splitting inside words
   * ("Docume/nt Number") reads as a rendering fault, and `overflow-wrap: break-word` is inherited
   * here from further up the cascade, so relaxing `word-break` alone leaves the splitting in place.
   * With both normal, a word wider than the content box overflows into the cell's own 16px padding
   * — empty space — so it stays readable without changing any spacing. Body cells keep their
   * ellipsis.
   */
  fullColumnHeadings: css`
    .ant-table-thead > tr > th.ant-table-cell-ellipsis,
    /* A sortable column wraps its label in .ant-table-column-title and Ant moves the ellipsis onto
       that span, so styling the cell alone leaves exactly the sortable headings still cut off
       ("Doc... Date", "Posti... Date"). */
    .ant-table-thead > tr > th.ant-table-cell-ellipsis .ant-table-column-title {
      overflow: visible;
      overflow-wrap: normal;
      text-overflow: clip;
      white-space: normal;
      word-break: normal;
    }
  `,
  cellActionsHover: css`
    .ant-table-cell-actions {
      opacity: 0;
      transition: opacity 0.2s;

      & > {
        pointer-events: none;
      }
    }

    .ant-table-cell-row-hover {
      .ant-table-cell-actions {
        opacity: 1;

        & > {
          pointer-events: auto;
        }
      }
    }

    .ant-table-cell-matched {
      opacity: 1;
      transition: opacity 0.2s;
    }

    .ant-table-cell-row-hover .ant-table-cell-matched {
      opacity: 0;
      pointer-events: none;
    }
  `,
};
